module.exports = __webpack_public_path__ + "static/media/travel_guru.5c868424.webp";